<template>
  <div>
    <Header :perks="perks"/>
    <section class="section">
      <div class="container">
        <div class="columns">
          <div class="column">
            <PageTitle
                title="Добро пожаловать в OptomNoutbuk.UZ"
                subtitle="Ноутбуки в Ташкенте - Ноутбуки в розницу по оптовым ценам">
            </PageTitle>
          </div>
          <div class="column has-text-centered">
            <a class="navbar-item" :href="'tel:'+contacts.phone_number">
              Звоните:
              <img alt="Телефон" src="../../assets/images/social/phone.png" width="16">
              <span class=" has-text-weight-bold">&nbsp; {{ contacts.phone_number }}</span>
            </a>
            <a class="navbar-item" :href="'https://telegram.me/'+contacts.telegram_username" target="_blank">
              Пишите:
              <img alt="Телеграм" src="../../assets/images/social/telegram.png" width="16">
              <span class=" has-text-weight-bold">&nbsp; @{{ contacts.telegram_username }}</span>
            </a>
          </div>
        </div>
      </div>
    </section>
    <CategoryTiles/>
    <BrandTiles/>
    <section class="section">
      <div class="container">
        <div class="field is-pulled-right">
          <div class="control">
            <span>Сортировка: </span>
            <span :class="['tag', {'is-success' : sorting.isSorted}]"
                  @click="sortLaptops">{{ sorting.price_text }}</span>
          </div>
        </div>
      </div>
    </section>
    <h2 class="title has-text-centered">Товары в наличии</h2>
    <div class="container ">
      <ProductsGrid :laptops="laptops" :columnWidth="6"/>
    </div>
    <section class="section has-text-centered">
      <button v-if="laptops.length < paging.count" class="button is-warning is-outlined is-large"
              @click="loadMore">Загрузить еще...
      </button>
    </section>
  </div>
</template>
<script>

import TopBar from '../components/header/TopBar'
import Header from "../components/header/HeaderBF";
import Features from "../components/Features";
import ProductsGrid from "../components/products/ProductsGrid";
import ProductDetails from "./products/Details";
import axios from 'axios'
import Slider from "../components/Slider";
import CategoryTiles from "../components/CategoryTiles";
import BrandTiles from '../components/BrandTiles'
import {API_URL} from "../../main";
import PageTitle from "../components/elements/PageTitle";
import Search from "../components/Search";

export default {
  name: 'homenew',
  components: {
    Header,
    Search,
    PageTitle,
    CategoryTiles,
    Slider,
    ProductDetails,
    ProductsGrid,
    Features,
    TopBar,
    BrandTiles
  },
  inject: ['openLoading', 'closeLoading'],
  data() {
    return {
      laptops: [],
      sorting: {
        isSorted: false,
        price_text: 'Цена',
      },
      paging: {
        count: Number,
        limit: 10,
        offset: 0
      },
      ordering: 'price_year',
      available_stock: true,
      perks: [],
      API_URL: process.env.VUE_APP_API_URL,
      MEDIA_URL: process.env.VUE_APP_MEDIA_URL,
      contacts: {
        phone_number: '',
        telegram_username: '',
      },
    }
  },
  methods: {
    fetchPerks() {
      axios.get(this.API_URL + '/products/perks')
          .then(response => {
            this.perks = response.data
          })
    },
    fetchPhoneNumber() {
      axios.get(this.API_URL + '/dollar/phone')
          .then(response => {
            this.contacts.phone_number = response.data[0].phone_number
            this.contacts.telegram_username = response.data[0].telegram_username
          })
    },
    fetchLaptops() {
      this.openLoading()
      axios.get(API_URL + '/laptops', {
        params: {
          ordering: this.ordering,
          limit: this.paging.limit,
          offset: this.paging.offset,
          active: this.available_stock
        }
      })
          .then(response => {
            this.closeLoading();
            this.paging.count = response.data.count;
            this.laptops = this.laptops.concat(response.data.results);
          })
    },
    loadMore() {
      this.paging.offset += 10;
      this.fetchLaptops()
    },
    sortLaptops() {
      if (this.ordering === 'price_year') {
        this.ordering = '-price_year';
        this.sorting.price_text = 'От дорогих к дешевым'
      } else {
        this.ordering = 'price_year';
        this.sorting.price_text = 'От дешевых к дорогим'
      }
      this.sorting.isSorted = true;
      this.laptops = [];
      this.paging.offset = 0;
      this.fetchLaptops()
    }
  },
  created() {
    this.fetchLaptops()
    this.fetchPerks()
    this.fetchPhoneNumber()
  }
}
</script>
<style>
.button {
  margin: 5px;
}

.tag {
  margin: 5px;
  cursor: pointer;
}
</style>
